module.exports = __webpack_public_path__ + "img/cred.37952c78.svg";